import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./Mission.css";
import { useLanguage } from "../../LanguageContext";

function Mission() {
    const { language, purposeText } = useLanguage();
    const isArmenian = language === "ARM";

    const missionDesc = [
        {
            header: purposeText[language][0].purposeMiniTitle1,
            title: purposeText[language][0].purposeTitle1,
            description: purposeText[language][0].purposeText1,
        },
        {
            header: purposeText[language][0].purposeMiniTitle2,
            title: purposeText[language][0].purposeTitle2,
            description: purposeText[language][0].purposeText2,
        },
        {
            header: purposeText[language][0].purposeMiniTitle3,
            title: purposeText[language][0].purposeTitle3,
            description: purposeText[language][0].purposeText3,
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    // // Refs for Swipers
    // const swiper1Ref = useRef(null);
    // const swiper2Ref = useRef(null);
    // const swiper3Ref = useRef(null);

    // const changeSlide = (index) => {
    //     setActiveIndex(index);
    //     if (swiper1Ref.current?.slideTo) swiper1Ref.current.slideTo(index);
    //     if (swiper2Ref.current?.slideTo) swiper2Ref.current.slideTo(index);
    //     if (swiper3Ref.current?.slideTo) swiper3Ref.current.slideTo(index);
    // };

    // // Slide change handler for Swipers
    // const handleSlideChange = (swiper) => {
    //     setActiveIndex(swiper.activeIndex);
    // };

    // Refs for Swipers
    const swiperRefs = useRef([]);

    const handleSlideChange = (swiper) => {
        const newIndex = swiper.activeIndex;
        setActiveIndex(newIndex);
        swiperRefs.current.forEach((ref) => {
            if (ref && ref !== swiper) {
                ref.slideTo(newIndex);
            }
        });
    };

    const dynamicStyles = {
        fontFamily: language === "ARM" && "Mardoto",
        fontWeight: language === "ARM" && 500,
    };

    return (
        <div className={`mission ${isArmenian && "arm-language"}`}>
            <div className="mission-header">
                <span style={dynamicStyles}>{purposeText[language][0].purposeHeadText1}</span>
                <div className="mission-header_icons">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.0164407 3.82196L0 12L3.99046 12L3.99046 3.99715C4.00629 3.99715 4.9794 4.00325 4.9794 4.0002L12 4.0002L12 -5.24537e-07L3.83761 -1.67747e-07C1.73064 -7.56487e-08 0.0219223 1.70984 0.0176598 3.82196"
                            fill="#243BE2"
                        />
                    </svg>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.17804 11.9836L0 12L0 8.00954L8.00285 8.00954C8.00285 7.99371 7.99675 7.0206 7.9998 7.0206L7.9998 0H12L12 8.16239C12 10.2694 10.2902 11.9781 8.17804 11.9823"
                            fill="#ADF233"
                        />
                    </svg>
                </div>
            </div>
            <div className="mission-title">
                <h1 style={dynamicStyles}>{purposeText[language][0].purposeHeadText2}</h1>
            </div>

            <div className="mission-container">
                <div className="mission-anim">
                    <svg
                        className={`animated-svg_1 ${activeIndex === 0 ? "position-1" : activeIndex === 1 ? "position-2" : "position-3"}`}
                        width="55"
                        height="55"
                        viewBox="0 0 55 55"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <mask id="path-1-inside-1_2_4208" fill="white">
                            <path d="M17.5173 54.9247L55 55L55 36.7104L18.3203 36.7104C18.3203 36.6378 18.3483 32.1778 18.3343 32.1778L18.3343 -6.09277e-07L-9.93556e-07 9.93555e-07L2.27701e-06 37.411C3.12125e-06 47.0679 7.83676 54.8995 17.5173 54.9191" />
                        </mask>
                        <path
                            d="M17.5173 54.9247L55 55L55 36.7104L18.3203 36.7104C18.3203 36.6378 18.3483 32.1778 18.3343 32.1778L18.3343 -6.09277e-07L-9.93556e-07 9.93555e-07L2.27701e-06 37.411C3.12125e-06 47.0679 7.83676 54.8995 17.5173 54.9191"
                            fill="#243BE2"
                        />
                        <path
                            d="M55 55L54.998 56L56 56.002L56 55L55 55ZM55 36.7104L56 36.7104L56 35.7104L55 35.7104L55 36.7104ZM18.3203 36.7104L17.3203 36.7104L17.3203 37.7104L18.3203 37.7104L18.3203 36.7104ZM18.3343 32.1778L17.3343 32.1778L17.3343 33.1778L18.3343 33.1778L18.3343 32.1778ZM18.3343 -6.09277e-07L19.3343 -6.967e-07L19.3343 -1L18.3343 -1L18.3343 -6.09277e-07ZM-9.93556e-07 9.93555e-07L-1.08098e-06 -0.999999L-1 -0.999999L-1 1.08098e-06L-9.93556e-07 9.93555e-07ZM17.5153 55.9247L54.998 56L55.002 54L17.5193 53.9247L17.5153 55.9247ZM56 55L56 36.7104L54 36.7104L54 55L56 55ZM55 35.7104L18.3203 35.7104L18.3203 37.7104L55 37.7104L55 35.7104ZM19.3203 36.7104C19.3203 36.7113 19.3203 36.7078 19.3203 36.696C19.3204 36.6857 19.3205 36.6713 19.3206 36.653C19.3208 36.6165 19.3211 36.565 19.3214 36.5005C19.3222 36.3717 19.3232 36.1914 19.3244 35.9772C19.3268 35.5487 19.3299 34.984 19.3325 34.4215C19.3351 33.8593 19.3373 33.2982 19.338 32.8774C19.3383 32.6673 19.3383 32.4902 19.3377 32.3649C19.3374 32.3029 19.3369 32.2498 19.3363 32.2106C19.336 32.1924 19.3355 32.1697 19.3346 32.1483C19.3342 32.1403 19.3332 32.1168 19.3306 32.0889C19.3298 32.0801 19.3262 32.0396 19.3165 31.9892C19.3132 31.9719 19.2994 31.8992 19.2649 31.8117C19.2433 31.7609 19.1717 31.6311 19.1171 31.5555C19.0007 31.4322 18.6105 31.2167 18.3343 31.1778L18.3343 33.1778C18.0581 33.1389 17.668 32.9234 17.5516 32.8002C17.4971 32.7246 17.4255 32.5949 17.4039 32.5442C17.3696 32.457 17.3559 32.3847 17.3527 32.368C17.3432 32.3187 17.3398 32.2798 17.3391 32.2731C17.3379 32.2592 17.3372 32.2486 17.3369 32.244C17.3366 32.2385 17.3364 32.2346 17.3364 32.2329C17.3362 32.2283 17.3363 32.2306 17.3366 32.2451C17.337 32.2713 17.3374 32.3141 17.3377 32.3743C17.3383 32.4931 17.3383 32.6651 17.338 32.8742C17.3373 33.2919 17.3351 33.8504 17.3325 34.4122C17.3273 35.5304 17.3203 36.6713 17.3203 36.7104L19.3203 36.7104ZM19.3343 32.1778L19.3343 -6.967e-07L17.3343 -5.21855e-07L17.3343 32.1778L19.3343 32.1778ZM18.3343 -1L-1.08098e-06 -0.999999L-9.06133e-07 1L18.3343 0.999999L18.3343 -1ZM-1 1.08098e-06L-0.999998 37.411L1 37.411L0.999999 9.06132e-07L-1 1.08098e-06ZM-0.999998 37.411C-0.999997 47.6218 7.28568 55.8984 17.5153 55.9191L17.5193 53.9191C8.38784 53.9006 1 46.514 1 37.411L-0.999998 37.411Z"
                            fill="#243BE2"
                            mask="url(#path-1-inside-1_2_4208)"
                        />
                    </svg>

                    <svg
                        className={`animated-svg_2 ${activeIndex === 0 ? "position-1" : activeIndex === 1 ? "position-2" : "position-3"}`}
                        width="55"
                        height="55"
                        viewBox="0 0 55 55"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M17.5173 54.9247L55 55L55 36.7104L18.3203 36.7104C18.3203 36.6378 18.3483 32.1778 18.3343 32.1778L18.3343 3.20542e-06L-9.93555e-07 4.80825e-06L2.27701e-06 37.411C3.12125e-06 47.0679 7.83675 54.8995 17.5173 54.9191"
                            fill="#3442A2"
                        />
                    </svg>

                    <svg
                        className={`animated-svg_3 ${activeIndex === 0 ? "position-1" : activeIndex === 1 ? "position-2" : "position-3"}`}
                        width="55"
                        height="55"
                        viewBox="0 0 55 55"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <mask id="path-1-inside-1_2_2501" fill="white">
                            <path d="M17.5173 54.9247L55 55L55 36.7104L18.3203 36.7104C18.3203 36.6378 18.3483 32.1778 18.3343 32.1778L18.3343 -6.09277e-07L-9.93556e-07 9.93555e-07L2.27701e-06 37.411C3.12125e-06 47.0679 7.83676 54.8995 17.5173 54.9191" />
                        </mask>
                        <path
                            d="M55 55L54.998 56L56 56.002L56 55L55 55ZM55 36.7104L56 36.7104L56 35.7104L55 35.7104L55 36.7104ZM18.3203 36.7104L17.3203 36.7104L17.3203 37.7104L18.3203 37.7104L18.3203 36.7104ZM18.3343 32.1778L17.3343 32.1778L17.3343 33.1778L18.3343 33.1778L18.3343 32.1778ZM18.3343 -6.09277e-07L19.3343 -6.967e-07L19.3343 -1L18.3343 -1L18.3343 -6.09277e-07ZM-9.93556e-07 9.93555e-07L-1.08098e-06 -0.999999L-1 -0.999999L-1 1.08098e-06L-9.93556e-07 9.93555e-07ZM17.5153 55.9247L54.998 56L55.002 54L17.5193 53.9247L17.5153 55.9247ZM56 55L56 36.7104L54 36.7104L54 55L56 55ZM55 35.7104L18.3203 35.7104L18.3203 37.7104L55 37.7104L55 35.7104ZM19.3203 36.7104C19.3203 36.7113 19.3203 36.7078 19.3203 36.696C19.3204 36.6857 19.3205 36.6713 19.3206 36.653C19.3208 36.6165 19.3211 36.565 19.3214 36.5005C19.3222 36.3717 19.3232 36.1914 19.3244 35.9772C19.3268 35.5487 19.3299 34.984 19.3325 34.4215C19.3351 33.8593 19.3373 33.2982 19.338 32.8774C19.3383 32.6673 19.3383 32.4902 19.3377 32.3649C19.3374 32.3029 19.3369 32.2498 19.3363 32.2106C19.336 32.1924 19.3355 32.1697 19.3346 32.1483C19.3342 32.1403 19.3332 32.1168 19.3306 32.0889C19.3298 32.0801 19.3262 32.0396 19.3165 31.9892C19.3132 31.9719 19.2994 31.8992 19.2649 31.8117C19.2433 31.7609 19.1717 31.6311 19.1171 31.5555C19.0007 31.4322 18.6105 31.2167 18.3343 31.1778L18.3343 33.1778C18.0581 33.1389 17.668 32.9234 17.5516 32.8002C17.4971 32.7246 17.4255 32.5949 17.4039 32.5442C17.3696 32.457 17.3559 32.3847 17.3527 32.368C17.3432 32.3187 17.3398 32.2798 17.3391 32.2731C17.3379 32.2592 17.3372 32.2486 17.3369 32.244C17.3366 32.2385 17.3364 32.2346 17.3364 32.2329C17.3362 32.2283 17.3363 32.2306 17.3366 32.2451C17.337 32.2713 17.3374 32.3141 17.3377 32.3743C17.3383 32.4931 17.3383 32.6651 17.338 32.8742C17.3373 33.2919 17.3351 33.8504 17.3325 34.4122C17.3273 35.5304 17.3203 36.6713 17.3203 36.7104L19.3203 36.7104ZM19.3343 32.1778L19.3343 -6.967e-07L17.3343 -5.21855e-07L17.3343 32.1778L19.3343 32.1778ZM18.3343 -1L-1.08098e-06 -0.999999L-9.06133e-07 1L18.3343 0.999999L18.3343 -1ZM-1 1.08098e-06L-0.999998 37.411L1 37.411L0.999999 9.06132e-07L-1 1.08098e-06ZM-0.999998 37.411C-0.999997 47.6218 7.28568 55.8984 17.5153 55.9191L17.5193 53.9191C8.38784 53.9006 1 46.514 1 37.411L-0.999998 37.411Z"
                            fill="#243BE2"
                            mask="url(#path-1-inside-1_2_2501)"
                        />
                    </svg>

                    {/* <div className="custom-pagination">
                        {missionDesc.map((_, index) => (
                            <React.Fragment key={index}>
                                <span
                                    className={`custom-number ${index <= activeIndex ? "active" : ""}`}
                                    onClick={() => {
                                        setActiveIndex(index); // Update activeIndex
                                        swiperRefs.current.forEach((ref) => ref?.slideTo(index)); // Sync all Swipers
                                    }}
                                >
                                    {index + 1}
                                </span>
                                {index < missionDesc.length - 1 && (
                                    <div className={`custom-progress ${index < activeIndex ? "completed" : ""}`}></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div> */}
                </div>
                <div className="mission-desc">
                    <div className="mission-desc_header">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.2671 0.0246587L0 0L0 5.98569L12.0043 5.98569C12.0043 6.00944 11.9951 7.46909 11.9997 7.46909V18L18 18L18 5.75642C18 2.59596 15.4352 0.0328814 12.2671 0.0264874"
                                fill="white"
                            />
                        </svg>
                        <Swiper
                            direction="vertical"
                            pagination={{ clickable: false }}
                            className="headerSwiperMission"
                            onSlideChange={handleSlideChange}
                            onSwiper={(swiper) => (swiperRefs.current[0] = swiper)}
                        >
                            {missionDesc.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <span style={dynamicStyles}>{item.header}</span>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className={`mission-content`}>
                        <Swiper
                            direction="vertical"
                            pagination={{ clickable: false }}
                            className="titleSwiperMission"
                            onSlideChange={handleSlideChange}
                            onSwiper={(swiper) => (swiperRefs.current[1] = swiper)}
                        >
                            {missionDesc.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <h2 style={dynamicStyles}>{item.title}</h2>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <Swiper
                            direction="vertical"
                            pagination={{ clickable: false }}
                            className="descriptionSwiperMission"
                            onSlideChange={handleSlideChange}
                            onSwiper={(swiper) => (swiperRefs.current[2] = swiper)}
                        >
                            {missionDesc.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <p style={dynamicStyles}>{item.description}</p>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className="mission-pagination">
                        {missionDesc.map((_, index) => (
                            <div
                                key={index}
                                className={`dot ${index === activeIndex ? "active" : ""}`}
                                onClick={() => swiperRefs.current.forEach((ref) => ref?.slideTo(index))}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Mission;
